import React, { useEffect, useState } from 'react';
import Checkbox from 'components/elements/atoms/Checkbox';
import { Icon, ICONS } from '../../Icons';
import FloatingInput from 'components/elements/atoms/FloatingInput/FloatingInput';
import ActionLink from 'components/elements/molecules/ActionLink/ActionLink';
import classNames from 'classnames';
import RectangularButton from 'components/elements/molecules/RectangularButton/RectangularButton';

export default function CourseTopicReadingList({
  courses,
  courseName,
  setCourseName,
  actions,
  selection,
  onSelection,
  topicName,
  setTopicName,
  createNewCourse,
  setCreateNewCourse,
  createNewTopic,
  setCreateNewTopic,
  type,
}) {
  const [expandedCourses, setExpandedCourses] = useState([]);

  const onSelect = (course, topic) => {
    if (createNewCourse) {
      return;
    }

    if (topic) {
      const index = selection.findIndex(
        (i) => i.type === 'topic' && i.topicId === topic._id,
      );

      if (index === -1) {
        onSelection([
          ...selection,
          { type: 'topic', topicId: topic._id, courseId: course.courseId },
        ]);
      } else {
        onSelection([
          ...selection.slice(0, index),
          ...selection.slice(index + 1),
        ]);
      }
    } else {
      const index = selection.findIndex(
        (i) => i.type === 'course' && i.courseId === course.courseId,
      );

      if (index === -1) {
        onSelection([
          ...selection,
          { type: 'course', courseId: course.courseId },
        ]);
      } else {
        onSelection([
          ...selection.slice(0, index),
          ...selection.slice(index + 1),
        ]);
      }
    }
  };

  const renderCourse = (course) => {
    const isExpanded = expandedCourses.indexOf(course.courseId) !== -1;
    const isSelected = !!selection.find(
      (i) => i.type === 'course' && i.courseId === course.courseId,
    );
    const isBold = !!selection.find((i) => i.courseId === course.courseId);
    return (
      <>
        <div
          className={classNames('mb-2 d-flex align-items-center mt-3')}
          data-course-id={`${type}-${course.courseId}`}
        >
          <Icon
            icon={isExpanded ? ICONS.CHEVRON_DOWN : ICONS.CHEVRON_RIGHT}
            className="mr-3 av-blue cursor-pointer"
            onClick={() => {
              if (createNewCourse) {
                return;
              }

              const index = expandedCourses.indexOf(course.courseId);

              if (isExpanded) {
                setExpandedCourses([
                  ...expandedCourses.slice(0, index),
                  ...expandedCourses.slice(index + 1),
                ]);
              } else {
                setExpandedCourses([...expandedCourses, course.courseId]);
              }

              if (!course.topics) {
                actions.getUserCourse(course.courseId);
              }
            }}
          />
          <Checkbox
            checked={isSelected}
            handleChange={() => {
              onSelect(course);
            }}
            className="m-0"
            labelClassName={classNames({
              'font-weight-bold': isBold,
            })}
          >
            {course.name}
          </Checkbox>
        </div>
        {isExpanded && renderTopics(course)}
      </>
    );
  };

  const renderNewCourseName = () => {
    return (
      <div>
        <div className="d-flex align-items-center">
          <ActionLink
            onClick={() => {
              setCreateNewCourse(false);
              setCourseName('');
            }}
            linkClassName="ml-auto"
            iconType="averPointIcon"
            iconName="CLOSE"
            iconSize={10}
          />
        </div>
        <FloatingInput
          placeholder=""
          labelName="Course name"
          value={courseName}
          onChange={(e) => {
            setCourseName(e.target.value);
          }}
          className="mb-2"
        />
        <div className="text-right">
          <RectangularButton
            className="next-button"
            onClick={() => {
              setCreateNewCourse(false);
            }}
            size="small"
          >
            Create Course
          </RectangularButton>
        </div>
      </div>
    );
  };

  const renderNewTopicName = () => {
    return (
      <div>
        <div className="d-flex align-items-center">
          <ActionLink
            onClick={() => {
              setCreateNewTopic(false);
              setTopicName('');
            }}
            linkClassName="ml-auto"
            iconType="averPointIcon"
            iconName="CLOSE"
            iconSize={10}
          />
        </div>
        <FloatingInput
          placeholder=""
          labelName="Topic name"
          value={topicName}
          onChange={(e) => {
            setTopicName(e.target.value);
          }}
        />
      </div>
    );
  };

  const renderCreateNewCourse = () => {
    if (createNewCourse) {
      return renderNewCourseName();
    }

    if (setCourseName) {
      return (
        <>
          <ActionLink
            label="New course"
            iconType="averPointIcon"
            iconName="ADD"
            linkClassName="av-blue"
            onClick={() => {
              setCreateNewCourse(true);
              onSelection([]);
            }}
          />
          {renderNewCourseCheckbox()}
        </>
      );
    }

    return null;
  };

  const renderNewCourseCheckbox = () => {
    if (!courseName) {
      return null;
    }

    return (
      <div className={classNames('mb-2 d-flex align-items-center mt-3')}>
        <Icon
          icon={ICONS.CHEVRON_RIGHT}
          className="mr-3 av-blue cursor-pointer"
        />
        <Checkbox
          checked={true}
          handleChange={() => {}}
          className="m-0"
          labelClassName={classNames({
            'font-weight-bold': true,
          })}
        >
          {courseName} (New)
        </Checkbox>
      </div>
    );
  };

  const renderCourses = () => {
    // if (createNewCourse) {
    //   return renderNewCourseName();
    // }

    if (createNewTopic) {
      return renderNewTopicName();
    }

    return (
      <div>
        {renderCreateNewCourse()}
        <div className="position-relative">
          {courses.map((i) => renderCourse(i))}
          {createNewCourse && (
            <div
              className="position-absolute h-100 w-100"
              style={{ top: 0, background: 'rgba(255, 255, 255, 0.5)' }}
            ></div>
          )}
        </div>
      </div>
    );
  };

  const renderTopic = (topic, course) => {
    const isSelected = selection.find(
      (i) =>
        (i.topicId === topic._id && i.type === 'topic') ||
        (i.courseId === course.courseId && i.type === 'course'),
    );

    return (
      <>
        <div className="mb-2">
          <Checkbox
            checked={isSelected}
            handleChange={() => {
              onSelect(course, topic);
            }}
            labelClassName={classNames({
              'font-weight-bold': isSelected,
            })}
          >
            {topic.name}
          </Checkbox>
        </div>
      </>
    );
  };

  const renderTopics = (course) => {
    if (!course.topics) {
      return (
        <div
          className="fa fa-spin fa-spinner text-primary"
          style={{ marginLeft: '50px' }}
        />
      );
    }

    return (
      <div style={{ marginLeft: '50px' }}>
        {course.topics.map((topic) => renderTopic(topic, course))}
        {setTopicName && (
          <ActionLink
            label="New topic"
            iconType="averPointIcon"
            iconName="ADD"
            linkClassName="av-blue"
            onClick={() => {
              setCreateNewTopic(true);
              setCourseName('');
              onSelection([{ type: 'course', courseId: course.courseId }]);
            }}
          />
        )}
      </div>
    );
  };

  return renderCourses();
}
